import React, { Fragment, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import ContentHeader from "../components/ContentHeader";
import { KPI } from "../components/KPI.js";
import { useLocation } from "react-router-dom";
import { BarChartComponent } from "../components/BarChartComponent.js";

const API_URL = process.env.REACT_APP_API_URL;

const Overview = () => {
	// const [error, setError] = useState();
	const location = useLocation();
    const [totalCosts, ] = useState(0);
    const [cloudCost, setCloudCost] = useState([]);
    
	// function retrieveTotalCosts() {
	// 	fetch(API_URL + "/get-cloud-costs")
	// 		.then((response) => {
	// 			if (response.status !== "200") {
	// 				// let err = Error;
	// 				// err.message = "Invalid response code: " + response.status;
	// 				// setError(err);
	// 			}
	// 			return response.json();
	// 		})
	// 		.then((json) => {
    //             setTotalCosts(json.CloudCosts.total_costs);
    //         });
	// }

    function retrieveCloudCost() {
		fetch(API_URL + "/get-cloud-cost")
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
                setCloudCost(json.CloudCost);
            });
	}

    
	useEffect(() => {
		// retrieveTotalCosts();
        retrieveCloudCost();
	}, [location]);

    return (
		<Fragment>
                <ContentHeader 
					title="Overview"
				/>

                <div className="text-left flex pt-10 ml-24 border-b border-solid border-border">
                    <ul className="text-left flex flex-col lg:flex-row lg:space-x-16 font-semibold text-lg">
                        <li className="border-primary">
							<div className="border-solid border-bottom border-primary border-b-2 h-12">
                                <a href="/#" className="block py-2 mb-4 pr-4 pl-3 cursor-pointer text-primary hover:text-primary lg:hover:bg-transparent lg:border-0 lg:p-0">
									<FontAwesomeIcon icon={icon({name: 'house', family: 'sharp', style: 'solid'})} className="pr-2 text-sm"/>
									Overview
								</a>
                            </div>
                        </li>
                        <li>
                            <div>
                                <a href="/#" className="block py-2 mb-4 pr-4 pl-3 cursor-pointer text-text-2 hover:text-primary lg:hover:bg-transparent lg:border-0 lg:p-0">
									<FontAwesomeIcon icon={icon({name: 'computer', family: 'sharp', style: 'solid'})} className="pr-2 text-sm"/>
									IT Components
								</a>
                            </div>
                        </li>
                        <li>
                            <div>
                                <a href="/#" className="block py-2 mb-4 pr-4 pl-3 cursor-pointer text-text-2 hover:text-primary lg:hover:bg-transparent lg:border-0 lg:p-0">
									<FontAwesomeIcon icon={icon({name: 'sitemap', family: 'sharp', style: 'solid'})} className="pr-2 text-sm"/>
									Organizations
								</a>
                            </div>
                        </li>
                        <li>
                            <div>
                                <a href="/#" className="block py-2 mb-4 pr-4 pl-3 cursor-pointer text-text-2 hover:text-primary lg:hover:bg-transparent lg:border-0 lg:p-0">
									<FontAwesomeIcon icon={icon({name: 'box-archive', family: 'sharp', style: 'solid'})} className="pr-2 text-sm"/>
									Products
								</a>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="text-left flex flex-row mt-10 ml-24 border-solid border-border">
                    <KPI 
                        className="flex-none"
                        title="Total Cloud Costs"
                        subtitle="Total Costs"
                        value={totalCosts}
                        format="currency"
                    />

                    <BarChartComponent
                        className="ml-24 flex-1"
                        data={cloudCost}
                        title="Trend by Day"
                        valueName="Total Costs"
                    />

                </div>

		</Fragment>
	);
};

export default Overview;